export default "__VITE_ASSET__tAsHJE7C__"